import React from 'react';
import './App.css'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ScopedCssBaseline from '@material-ui/core/ScopedCssBaseline';
import Navbar from './components/navbar/Navbar';
import Home from './components/home/Home';
import About from './components/about/About';
import Footer from './components/footer/Footer';
import Contact from './components/contact/Contact';
import Projects from './components/projects/Projects';
import Testimonials from './components/testimonials/Testimonials';
import Resume from './components/resume/Resume';

function App() {
  return (
    <React.Fragment>
      <ScopedCssBaseline>
        <Navbar />
        <Router>
          <Switch>
            <Route path='/about' component={About} />
            <Route path='/projects' component={Projects} />
            <Route path='/testimonials' component={Testimonials} />
            <Route path='/contact' component={Contact} />
            <Route path='/resume' component={Resume} />
            <Route path='/' component={Home} />
          </Switch>
        </Router>
        <Footer />
      </ScopedCssBaseline>
    </React.Fragment>
  );
}

export default App;


